import { changeBillingStatus } from 'feature/billing/billingSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import { Button, Dialog, Stack, Typography } from 'styles';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

interface IChangeStatusModal {
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	status: string;
}

const ChangeStatusModal = ({ open, setOpen, status }: IChangeStatusModal) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.DB_LABELS,
	});
	const dispatch = useDispatch<AppDispatch>();

	const onConfirm = () => {
		setOpen(false);
		dispatch(changeBillingStatus(''));
	};

	const getToStatus = (status: string) => {
		switch (status) {
			case 'not_billed':
				return 'sent_for_billing';
			case 'sent_for_billing':
				return 'billed';
			case 'billed':
				return 'settled';
			default:
				return '';
		}
	};

	return (
		<Dialog
			open={open}
			variant="confirm"
			title={tClientLabels('dialog.billing.title')}
			close={false}
			events={false}
			actions={null}
			type="billingChangeStatus"
		>
			<Typography variant="body">
				{tClientLabels('dialog.billing.content', {
					fromStatus: tDbLabels(`claim_billing_status.${status}`),
					toStatus: tDbLabels(`claim_billing_status.${getToStatus(status)}`),
				})}
			</Typography>

			<Stack direction={'row'} gap={'20px'} justifyContent={'flex-end'} mt={4}>
				<Button variant="outlined" onClick={() => setOpen(false)}>
					{tClientLabels('commons.buttons.cancel')}
				</Button>
				<Button variant="contained" onClick={onConfirm}>
					{tClientLabels('commons.buttons.confirm')}
				</Button>
			</Stack>
		</Dialog>
	);
};

export default ChangeStatusModal;
